import { useQuery } from '@tanstack/react-query';
import { icCidService } from '../../../services/icCids/ICcIdService';

/**
 * Verifica se o backend está com alocação atômica de ICCID habilitada
 * (FastchipAllocation.EnableBackendAllocation no appsettings).
 *
 * Lê GET /icCids/allocation-flag — endpoint de configuração, sem COUNT na base.
 * A sonda anterior usava GET /icCids/available-count (PR) só para extrair este booleano.
 *
 * Quando true, o modal de criação de contrato deve enviar allocateFastchipIccid=true
 * em vez de chipCcid, delegando a reserva ao backend via SKIP LOCKED.
 */
export function useFastchipAllocationFlag(enabled: boolean) {
  const query = useQuery({
    queryKey: ['icCids', 'allocation-flag'],
    queryFn: () => icCidService.getAllocationFlag(),
    enabled,
    staleTime: 10 * 60 * 1000,
    retry: 0,
  });

  return query.data?.backendAllocationEnabled ?? false;
}
